var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.82813 0C1.71391 0 0 1.67893 0 3.75V26.25C0 28.3211 1.71391 30 3.82813 30H26.1719C28.2861 30 30 28.3211 30 26.25V3.75C30 1.67893 28.2861 0 26.1719 0H3.82813ZM4.45059 24.3286L8.44044 8.58241L14.2882 4.80576L22.5115 7.27276L13.4049 9.95297L4.45059 24.3286ZM13.8922 12.1154L5.1511 25.1814L18.8567 24.3286L19.8009 18.7855L13.8922 12.1154ZM21.5064 18.6027L15.6892 11.354L23.5471 7.91236L25.7399 18.024L19.9531 23.7804L21.5064 18.6027Z",
    fill: "#F7A246"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.82813 0C1.71391 0 0 1.67893 0 3.75V26.25C0 28.3211 1.71391 30 3.82813 30H26.1719C28.2861 30 30 28.3211 30 26.25V3.75C30 1.67893 28.2861 0 26.1719 0H3.82813ZM4.45059 24.3286L8.44044 8.58241L14.2882 4.80576L22.5115 7.27276L13.4049 9.95297L4.45059 24.3286ZM13.8922 12.1154L5.1511 25.1814L18.8567 24.3286L19.8009 18.7855L13.8922 12.1154ZM21.5064 18.6027L15.6892 11.354L23.5471 7.91236L25.7399 18.024L19.9531 23.7804L21.5064 18.6027Z",
    fill: "#F7A246"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRmLogo);
export default __webpack_public_path__ + "static/media/RMLogo.830ec184bec224b7ce3339af59a204e4.svg";
export { ForwardRef as ReactComponent };